export enum Components {
  PolicyView = 'policyView',
  AddVehicle = 'addVehicle',
  AddDriver = 'addDriver'
}
